var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 91,
    viewBox: "0 0 103 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.296 90.8114H91.6819C99.902 90.8114 105.026 81.8974 100.916 74.7982L60.7232 5.35464C56.6132 -1.74452 46.3648 -1.74452 42.2547 5.35464L2.06178 74.7982C-2.04825 81.8974 3.07595 90.8114 11.296 90.8114ZM51.489 53.4474C48.5532 53.4474 46.1513 51.0454 46.1513 48.1097V37.4343C46.1513 34.4985 48.5532 32.0966 51.489 32.0966C54.4247 32.0966 56.8267 34.4985 56.8267 37.4343V48.1097C56.8267 51.0454 54.4247 53.4474 51.489 53.4474ZM56.8267 74.7982H46.1513V64.1228H56.8267V74.7982Z",
    fill: "#F4A15C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.e840a4b6.svg";
export { ForwardRef as ReactComponent };